import apiClient from '../../apiClient';

export const fetchSectionHeader = async ({ language }, section = "Promotion") => {
  try {
    const response = await apiClient.post('/section_page/section_header/', {
      language,
      section,
    });
    return {
      title: response.data.Title,
      description: response.data.Description,
      imageUrl: response.data.image,
    };
  } catch (error) {
    console.error('Error fetching section header:', error);
    throw error;
  }
};

export default {
  fetchSectionHeader,
};
